import { PostHogProvider } from "posthog-js/react"
import React from "react"
import { IS_LOCALHOST } from "utils/constants"
import { isShadow } from "utils/shadow"

type Props = {
  children: React.ReactNode
}

const PostHogProviderWrapper = (props: Props) => {
  if (IS_LOCALHOST || isShadow()) {
    return <>{props.children}</>
  }

  return (
    <PostHogProvider
      apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
      options={{
        debug: IS_LOCALHOST,
        api_host: `${window.location.origin}/gateway`,
        person_profiles: "identified_only",
        capture_pageview: false,
        capture_pageleave: false,
        defaults: "2025-11-30",
        capture_dead_clicks: false,
      }}
    >
      {props.children}
    </PostHogProvider>
  )
}

export default PostHogProviderWrapper
